<template>
  <k-page class="page-foundations">
    <div class="page-foundations__controls">
      <el-tooltip content="Обновить данные" placement="top">
        <el-button @click="update" type="primary" icon="el-icon-refresh-left" circle size="mini" :loading="isFoundationsLoading"></el-button>
      </el-tooltip>

      <el-tooltip content="Добавить фонд" placement="top">
        <el-button @click="handleAdd()" type="success" icon="el-icon-plus" circle size="mini"></el-button>
      </el-tooltip>
    </div>

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="foundationsCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-foundations-list
      :foundations="foundations"
      @edit="setFoundation"
      @delete="deleteFoundation"
    />

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="foundationsCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-foundation-edit-form
      :dialogFormVisible="activeFoundation !== '' || creatigNew"
      :foundation="foundation"
      @cancel="handleCancel"
      @update="handleUpdateAfterAdd"
    />
  </k-page>
</template>

<script>
/**
 * Page: Страница фондов
 *
 * @version 1.0.0
 */


import { mapGetters, mapActions } from 'vuex';


// Components
import KPage from '@/components/KPage.vue';
import KFoundationEditForm from '@/components/KFoundationEditForm.vue';
import KFoundationsList from '@/components/KFoundationsList.vue';


const NUMBER_OF_FOUNDATIONS_PER_PAGE = 10;

export default {
  name: 'page-foundations',

  data() {
    return {
      activeFoundation: '',
      creatigNew: false,
      currentPage: 0,
    };
  },

  computed: {
    // Общее количество страниц
    numberOfPages() {
      return Math.ceil(this.foundationsCount / NUMBER_OF_FOUNDATIONS_PER_PAGE);
    },

    foundation() {
      const foundation = this.foundations.find(item => item._id === this.activeFoundation);

      return this.creatigNew || !foundation
        ? {}
        : foundation;
    },

    ...mapGetters({
      isFoundationsLoading: 'foundations/isFoundationsLoading',
      foundations: 'foundations/foundations',
      foundationsCount: 'foundations/foundationsCount',
    }),
  },

  async created() {
    await this.update();
  },

  methods: {
    async update() {
      await this.getFoundations({
        limit: NUMBER_OF_FOUNDATIONS_PER_PAGE,
        offset: this.currentPage,
      });
    },

    setFoundation(id) {
      this.activeFoundation = id;
    },

    handleCancel() {
      this.creatigNew = false;
      this.activeFoundation = '';
    },

    async handleUpdateAfterAdd() {
      await this.update();
      this.creatigNew = false;
      this.activeFoundation = '';
    },

    async deleteFoundation(id) {
      console.debug('id', id);
      await this.deleteFoundations([id]);
      await this.update();
    },

    // Добавление акции
    handleAdd() {
      this.creatigNew = true;
    },

    async setCurrentPage(numberOfPage) {
      this.currentPage = numberOfPage - 1;
      await this.update();
    },

    ...mapActions({
      deleteFoundations: 'foundations/deleteFoundations',
      getFoundations: 'foundations/getFoundations',
    }),
  },

  components: {
    KPage,
    KFoundationEditForm,
    KFoundationsList,
  },
};
</script>

<style lang="scss">
  .page-foundations {
    display: flex;
    flex-direction: column;

    &__controls {
      margin-bottom: 24px;
    }
  }
</style>
